export const DefaultAssistantWidth = 450;
export const MinAssistantWidth = 360;
export const MaxAssistantWidth = 800;

export const UserMessageBackgroundColor = "rgba(155, 8, 224, 0.07)";
export const UserMessagePadding = "6px";

export const MaxChatStyles = {
  width: `${MaxAssistantWidth}px`,
  maxWidth: "unset",
  position: "fixed" as const,
  left: "50%",
  transform: "translateX(-50%)",
  height: "calc(100vh - 16px - 48px)",
  transition: "width 0.25s ease-in, transform 0.6s ease-in-out, left 0.6s ease-in-out",
};
